import React, { useState } from "react";
import { FaTrash } from "react-icons/fa";

const NumberSentInvitation = () => {
  const [membersPhone, setMembersPhone] = useState([
    { name: "", email: "", contact: "", role: "" },
  ]);

  // ADD MEMBER
  const handleAddMember = () => {
    setMembersPhone([
      ...membersPhone,
      { name: "", email: "", contact: "", role: "" },
    ]);
  };

  // REMOVE MEMBER (Minimum 1 member always)
  const handleRemoveMember = (index) => {
    if (membersPhone.length > 1) {
      setMembersPhone(membersPhone.filter((_, i) => i !== index));
    }
  };

  return (
    <div className="form_boxx profilss p-4">
      <p>Add members via phone number. Members receive an SMS notification.</p>

      {membersPhone.map((m, i) => (
        <div key={i} className="member-block">
          <div className="d-flex justify-content-between mb-3">
            <h5>Member–{i + 1}</h5>
            <div className="d-flex align-items-center">
              {i > 0 && (
                <button
                  className="delete-btns"
                  onClick={() => handleRemoveMember("phone", i)}
                >
                  {" "}
                  <FaTrash size={18} />
                </button>
              )}
              <button
                className="add-btn ml-1"
                onClick={() => handleAddMember("phone")}
              >
                +
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 mb-3">
              <label htmlFor="">Name</label>
              <input className="form-control" placeholder="Enter name" />
            </div>
            <div className="col-lg-6 mb-3">
              <label htmlFor="">Email</label>
              <input className="form-control" placeholder="Enter email" />
            </div>
            <div className="col-lg-6 mb-3">
              <label htmlFor="">Contact No.</label>
              <input className="form-control" placeholder="Enter contact no." />
            </div>
            <div className="col-lg-6 mb-3">
              <label htmlFor="">Role type</label>
              <input className="form-control" placeholder="Choose role type" />
            </div>
          </div>

          {/* <div className="d-flex justify-content-end mb-3">
                       {i > 0 && <button className="btn btn-danger me-2" onClick={() => handleRemoveMember("email", i)}>Delete</button>}
                       <button className="btn btn-success" onClick={() => handleAddMember("email")}>Add</button>
                     </div> */}
        </div>
      ))}

      <div className="invite-send">
        <button className="invite-btns cancel">Cancel</button>
        <button className="invite-btns send">Send</button>
      </div>
    </div>
  );
};

export default NumberSentInvitation;
